module.exports = __webpack_public_path__ + "static/img/LxwlzjscJ.c8b8944d.png";